import { render } from "./PostIndex.vue?vue&type=template&id=71c1a91b"
import script from "./PostIndex.vue?vue&type=script&lang=js"
export * from "./PostIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__